var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ExamEditor',{staticClass:"mt-4",attrs:{"editorText":_vm.editorText,"EditType":_vm.markdown,"showButton":false},on:{"updateDesc":function($event){return _vm.onUpdateExamDescription($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }